<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header title="Reset Your Password"></page-header>
    <update-password-form v-on:submit="submitUpdatePassword" ></update-password-form>
    <app-footer :pages="pages" class="w-full pin-b"></app-footer>
  </div>
</template>

<script>
    import UpdatePasswordForm from "@/views/User/Update-Password/UpdatePasswordForm";
    import PageHeader from "@/component/PageHeader";
    import AppFooter from "@/component/AppFooter";
    import LernerHeader from '@/component/Header';
    import { CHANGE_DOC_TITLE, SHOW_NOTIFICATION } from '@/store/actions/app.actions';
    import {mapGetters} from "vuex";
    import {UPDATE_PASSWORD} from "@/store/actions/auth.actions";

    export default {
        name: 'update-user-password',
        components: {
            PageHeader,
            UpdatePasswordForm,
            LernerHeader,
            AppFooter
        },

        data: () => {
            return {
                pending: false
            }
        },

        computed: {
            ...mapGetters([
                'pages'
            ])
        },

        created: function () {
            this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Update Password', useBaseTitle: true})
        },

        methods: {
            submitUpdatePassword(data) {
                this.pending = true;

                this.$store.dispatch(UPDATE_PASSWORD, data)
                    .then(() => {
                        this.$store.dispatch(SHOW_NOTIFICATION, {
                            type: 'success',
                            message: 'Your password has been updated'
                        });
                        this.$router.push({name: 'admin'});
                    })
                    .finally(() => {
                        this.pending = false;
                    });
            }
        }
    }
</script>